(function ($) {

    $(document).on( 'click', '#menu-toggler', function() {

        if($(this).hasClass('open')){
			$('#masthead').removeClass('menu-open');
            $(this).removeClass('open');
            $('html').removeClass('noscroll');
            $('#primary-nav').removeClass('visible');
        } else {
			$('#masthead').addClass('menu-open');
            $(this).addClass('open');
            $('html').addClass('noscroll');
            $('#primary-nav').addClass('visible');
        }

    });

	$( window ).scroll(function() {

		if ($(window).scrollTop() > 160) {
			$('#masthead .header-wrapper').addClass('h-shadow');
		} else {
			$('#masthead .header-wrapper').removeClass('h-shadow');
		}

	});

    $(document).on( 'click', '.menu-item-has-children>a', function(event) {

		event.preventDefault();
		$(this).parent().toggleClass('open');

    });


})
(jQuery);


(function(){

	var doc = document.documentElement;
	var w = window;
  
	var prevScroll = w.scrollY || doc.scrollTop;
	var curScroll;
	var direction = 0;
	var prevDirection = 0;
  
	var header = document.getElementById('masthead');
  
	var checkScroll = function() {
  
	  /*
	  ** Find the direction of scroll
	  ** 0 - initial, 1 - up, 2 - down
	  */
  
	  curScroll = w.scrollY || doc.scrollTop;
	  if (curScroll > prevScroll) { 
		//scrolled up
		direction = 2;
	  }
	  else if (curScroll < prevScroll) { 
		//scrolled down
		direction = 1;
	  }
  
	  if (direction !== prevDirection) {
		toggleHeader(direction, curScroll);
	  }
  
	  prevScroll = curScroll;
	};
  
	var toggleHeader = function(direction, curScroll) {
	  if (direction === 2 && curScroll > 52) { 
  
		//replace 52 with the height of your header in px
  
		header.classList.add('hide');
		prevDirection = direction;
	  }
	  else if (direction === 1) {
		header.classList.remove('hide');
		prevDirection = direction;
	  }
	};
  
	window.addEventListener('scroll', checkScroll);
  
  })();